








import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Menu extends Vue {
  private menus = [
    { title: '概要', link: '/about' },
    { title: '使用方法', link: '/manual' },
    { title: '更新履歴', link: '/history' },
    { title: 'ツール', link: '/tool' },
  ];
}
